import { render } from "./FormComp.vue?vue&type=template&id=64e17ece&scoped=true"
import script from "./FormComp.vue?vue&type=script&lang=js"
export * from "./FormComp.vue?vue&type=script&lang=js"

import "./FormComp.vue?vue&type=style&index=0&id=64e17ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e17ece"]])

export default __exports__